import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { stockSearchSchema } from '../../features/inventory/search'
import { StockLevelsPage } from '../../features/inventory/stock-levels-page'

export const Route = createFileRoute('/_app/stock')({
  staticData: { crumb: 'stockLevels' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'inventory.read'),
  validateSearch: stockSearchSchema,
  component: StockLevelsPage,
})
